export var ElliottWaveScenarioType;
(function (ElliottWaveScenarioType) {
    ElliottWaveScenarioType["impulse"] = "impulse";
    ElliottWaveScenarioType["leadingDiagonal"] = "leadingDiagonal";
    ElliottWaveScenarioType["endingDiagonal"] = "endingDiagonal";
    ElliottWaveScenarioType["zigzag"] = "zigzag";
    ElliottWaveScenarioType["flat"] = "flat";
    ElliottWaveScenarioType["triangle"] = "triangle";
})(ElliottWaveScenarioType || (ElliottWaveScenarioType = {}));
export var ElliottWaveDirection;
(function (ElliottWaveDirection) {
    ElliottWaveDirection["bullish"] = "bullish";
    ElliottWaveDirection["bearish"] = "bearish";
    ElliottWaveDirection["neutral"] = "neutral";
})(ElliottWaveDirection || (ElliottWaveDirection = {}));
export var ElliottWaveDegree;
(function (ElliottWaveDegree) {
    ElliottWaveDegree["minor"] = "minor";
    ElliottWaveDegree["intermediate"] = "intermediate";
    ElliottWaveDegree["primary"] = "primary";
})(ElliottWaveDegree || (ElliottWaveDegree = {}));
export var ElliottWaveLeg;
(function (ElliottWaveLeg) {
    ElliottWaveLeg["wave1"] = "wave1";
    ElliottWaveLeg["wave2"] = "wave2";
    ElliottWaveLeg["wave3"] = "wave3";
    ElliottWaveLeg["wave4"] = "wave4";
    ElliottWaveLeg["wave5"] = "wave5";
    ElliottWaveLeg["waveA"] = "waveA";
    ElliottWaveLeg["waveB"] = "waveB";
    ElliottWaveLeg["waveC"] = "waveC";
})(ElliottWaveLeg || (ElliottWaveLeg = {}));
export var ElliottWaveScenarioState;
(function (ElliottWaveScenarioState) {
    ElliottWaveScenarioState["active"] = "active";
    ElliottWaveScenarioState["invalidated"] = "invalidated";
    ElliottWaveScenarioState["completed"] = "completed";
    ElliottWaveScenarioState["superseded"] = "superseded";
    ElliottWaveScenarioState["expired"] = "expired";
})(ElliottWaveScenarioState || (ElliottWaveScenarioState = {}));
export var ElliottWaveEventCategory;
(function (ElliottWaveEventCategory) {
    ElliottWaveEventCategory["scenarioActivated"] = "scenarioActivated";
    ElliottWaveEventCategory["selectionChanged"] = "selectionChanged";
    ElliottWaveEventCategory["actionableStarted"] = "actionableStarted";
    ElliottWaveEventCategory["actionableEnded"] = "actionableEnded";
    ElliottWaveEventCategory["invalidationHit"] = "invalidationHit";
    ElliottWaveEventCategory["target1Hit"] = "target1Hit";
    ElliottWaveEventCategory["target2Hit"] = "target2Hit";
    ElliottWaveEventCategory["target3Hit"] = "target3Hit";
    ElliottWaveEventCategory["terminalWarning"] = "terminalWarning";
    ElliottWaveEventCategory["completed"] = "completed";
})(ElliottWaveEventCategory || (ElliottWaveEventCategory = {}));
export var ElliottWaveSelectionRole;
(function (ElliottWaveSelectionRole) {
    ElliottWaveSelectionRole["primary"] = "primary";
    ElliottWaveSelectionRole["bestBullish"] = "bestBullish";
    ElliottWaveSelectionRole["bestBearish"] = "bestBearish";
})(ElliottWaveSelectionRole || (ElliottWaveSelectionRole = {}));
export var ElliottWaveAnchorRole;
(function (ElliottWaveAnchorRole) {
    ElliottWaveAnchorRole["origin"] = "origin";
    ElliottWaveAnchorRole["wave1"] = "wave1";
    ElliottWaveAnchorRole["wave2"] = "wave2";
    ElliottWaveAnchorRole["wave3"] = "wave3";
    ElliottWaveAnchorRole["wave4"] = "wave4";
    ElliottWaveAnchorRole["wave5"] = "wave5";
    ElliottWaveAnchorRole["waveA"] = "waveA";
    ElliottWaveAnchorRole["waveB"] = "waveB";
    ElliottWaveAnchorRole["waveC"] = "waveC";
    ElliottWaveAnchorRole["invalidation"] = "invalidation";
    ElliottWaveAnchorRole["target1"] = "target1";
    ElliottWaveAnchorRole["target2"] = "target2";
    ElliottWaveAnchorRole["target3"] = "target3";
    ElliottWaveAnchorRole["channelUpper"] = "channelUpper";
    ElliottWaveAnchorRole["channelLower"] = "channelLower";
    ElliottWaveAnchorRole["zoneConfluence"] = "zoneConfluence";
})(ElliottWaveAnchorRole || (ElliottWaveAnchorRole = {}));
export const ELLIOTT_WAVE_SUPPORTED_DURATIONS = ['240m', '1d'];
export const ELLIOTT_WAVE_SUPPORTED_DEGREES = [ElliottWaveDegree.minor, ElliottWaveDegree.intermediate, ElliottWaveDegree.primary];
export const ELLIOTT_WAVE_SELECTION_ROLES = [
    ElliottWaveSelectionRole.primary,
    ElliottWaveSelectionRole.bestBullish,
    ElliottWaveSelectionRole.bestBearish
];
export function getSupportedElliottWaveDurations() {
    return [...ELLIOTT_WAVE_SUPPORTED_DURATIONS];
}
export function getSupportedElliottWaveDegrees() {
    return [...ELLIOTT_WAVE_SUPPORTED_DEGREES];
}
export function getSupportedElliottWaveSelectionRoles() {
    return [...ELLIOTT_WAVE_SELECTION_ROLES];
}
//# sourceMappingURL=ElliottWaveTypes.js.map